/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { withLocalization, Text as TextType } from 'hocs/localization'
import * as styles from '../../ConfirmEmail.scss'

interface IProps {
  t: TextType,
}

const ConfirmEmailUserAlreadyActivated: React.FC<IProps> = ({ t }) => {
  return (
    <React.Fragment>
      <div className={styles.loginTitle}>
        <h2>{t('alreadyActivated.header')}</h2>
      </div>
      <div className={styles.confirmBody}>
        {t('alreadyActivated.message')}
      </div>
    </React.Fragment>
  )
}

export default withLocalization('auth.confirmEmail')(ConfirmEmailUserAlreadyActivated)
